import { p as proxyCustomElement, H, h, d as Host } from './p-ae815584.js';
import { b as bem } from './p-c44c2366.js';
import { d as defineCustomElement$2 } from './p-db87170c.js';
import { r as resolveAppearance } from './p-c01ca34a.js';

const cosmosActionMenuGroupCss = ".cosmos-action-menu-group{display:-ms-flexbox;display:flex;-ms-flex-direction:column;flex-direction:column;gap:2px;padding-bottom:var(--cosmos-action-menu-group-padding-bottom, 8px)}.cosmos-action-menu-group__label{--cosmos-text-color:var(--cosmos-action-menu-group-color);--cosmos-text-font-family:var(--cosmos-action-menu-group-font-family);--cosmos-text-font-size:var(--cosmos-action-menu-group-font-size);--cosmos-text-font-style:var(--cosmos-action-menu-group-font-style);--cosmos-text-font-weight:var(--cosmos-action-menu-group-font-weight);--cosmos-text-letter-spacing:var(--cosmos-action-menu-group-letter-spacing);--cosmos-text-line-height:var(--cosmos-action-menu-group-line-height);--cosmos-text-text-transform:var(--cosmos-action-menu-group-text-transform);-ms-flex-align:center;align-items:center;display:-ms-flexbox;display:flex;height:36px;padding:0 8px 0 8px}";
const CosmosActionMenuGroupStyle0 = cosmosActionMenuGroupCss;

const CosmosActionMenuGroup$1 = /*@__PURE__*/ proxyCustomElement(class CosmosActionMenuGroup extends H {
    constructor() {
        super();
        this.__registerHost();
        this.__attachShadow();
        this.generateClassNames = bem('cosmos-action-menu-group');
        this.appearance = undefined;
        this.label = undefined;
        this.computedAppearance = undefined;
    }
    handleAppearanceChange(appearance) {
        this.computedAppearance = appearance;
    }
    componentDidLoad() {
        resolveAppearance({
            instance: this,
            modeToAppearanceMap: { dark: 'light', light: 'dark' },
            callback: this.handleAppearanceChange.bind(this),
        });
    }
    render() {
        return (h(Host, { key: '2badb5a096e7c79c84eda5d0cfdc1e4f37d18f8c', role: "group", "aria-label": this.label }, h("div", { key: '9e6ed0417f8ec41b332a36af3b680c8732d0b2ce', class: this.generateClassNames({ appearance: this.computedAppearance }), part: "base" }, this.label && (h("div", { key: '9d1d55c5239b141aa4a23d3db744b6bbcbbc83d4', class: this.generateClassNames('label') }, h("cosmos-text", { key: '23574327ab98e0ac58774eaf6dccc7a0f9b39725', exportparts: "base: label", size: "x-small", weight: "medium", clamp: 1, appearance: this.computedAppearance, kind: "subtle" }, this.label))), h("slot", { key: '71b178f8b548a4aed832dd917ff3965a0f5591ad' }))));
    }
    get element() { return this; }
    static get watchers() { return {
        "appearance": ["handleAppearanceChange"]
    }; }
    static get style() { return CosmosActionMenuGroupStyle0; }
}, [1, "cosmos-action-menu-group", {
        "appearance": [513],
        "label": [513],
        "computedAppearance": [32]
    }, undefined, {
        "appearance": ["handleAppearanceChange"]
    }]);
function defineCustomElement$1() {
    if (typeof customElements === "undefined") {
        return;
    }
    const components = ["cosmos-action-menu-group", "cosmos-text"];
    components.forEach(tagName => { switch (tagName) {
        case "cosmos-action-menu-group":
            if (!customElements.get(tagName)) {
                customElements.define(tagName, CosmosActionMenuGroup$1);
            }
            break;
        case "cosmos-text":
            if (!customElements.get(tagName)) {
                defineCustomElement$2();
            }
            break;
    } });
}

const CosmosActionMenuGroup = CosmosActionMenuGroup$1;
const defineCustomElement = defineCustomElement$1;

export { CosmosActionMenuGroup, defineCustomElement };
